import { assets } from "./assets";

export interface TeamMember {
  name: string;
  role: string;
  bio: string;
  image: string;
}

export const founder = {
  name: "Phaniraj Jaligama",
  role: "Chairman & Founder",
  quote:
    "We don't believe in just giving money. We believe in giving thought, in giving ideas, and in giving our own involvement.",
  image: assets.team.ceo,
};

export const teamMembers: TeamMember[] = [
  {
    name: "Phaniraj Jaligama",
    role: "Chairman & Founder",
    bio: "Visionary leader with 4+ years of experience in community development and social entrepreneurship.",
    image: assets.team.ceo,
  },
  {
    name: "Srilatha Kusumba",
    role: "Chief Customer Officer & Head Quality",
    bio: "Leads donor experience and quality standards so every program touchpoint stays clear, caring, and accountable.",
    image: assets.team.cco,
  },
  {
    name: "Prashanth Kumar Surabhi",
    role: "Executive Director",
    bio: "Strategic planner with expertise in nonprofit management and international development programs.",
    image: assets.team.coo,
  },
  {
    name: "Marupaka Dattu",
    role: "Community Outreach Coordinator",
    bio: "Chartered Accountant with 3+ years in nonprofit financial management and grant administration.",
    image: assets.team.director,
  },
];

export const aboutStats = [
  { value: "4+", label: "Years of Service" },
  { value: "10+", label: "Projects Completed" },
];
